import { SxProps } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import { ChipConfig, DefaultChip } from '@omnea-app/frontend/components/shared/ui/chip/DefaultChip'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'
import { RowGroupingColumnTableCell } from '../../row-grouping/components/RowGroupingColumnTableCell'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type ChipSingleColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'chip-single'> & {
  columnType: 'chip-single'
  getChipSx?: (row: T) => SxProps
  getColor?: (row: T) => ChipConfig['color']
  valueGetter: GridColDef<T>['valueGetter']
}

export const getChipColumn = <T extends GridValidRowModel>({ style, ...config }: ChipSingleColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupingValueGetter: config.valueGetter,
  renderCell: (params) => {
    if (!isDefined(params.value)) return null
    if (params.rowNode.type === 'group') {
      return <RowGroupingColumnTableCell columnHeaderName={config.headerName} value={params.value} id={params.id} />
    }
    if (params.value.length === 0) return null

    const chipSx = config.getChipSx ? config.getChipSx(params.row) : {}
    const color = config.getColor ? config.getColor(params.row) : 'neutral'

    return (
      <DefaultChip
        {...(config?.getDataTestId ? { ['data-testid']: config.getDataTestId(params) } : {})}
        sx={chipSx}
        label={params.value}
        color={color}
      />
    )
  },
})
